<template>
  <div class="content-calendar-new-page">
    <div class="calendar-test-mode-indicator-wrap">
      <CalendarTestModeIndicator />
    </div>
    <!--<StepsProgressBar class="content-calendar-new-page__progressbar" :currentStep="activeStep" :numberOfSteps="totalNumberOfSteps" :fontSize="19" color="teal" />-->

    <StepCalendarConfig
      class="content-calendar-new-page__step-container"
      :customerId="customerId"
      @proceed="
        async () => {
          await router.push({ name: 'CalendarPosts', params: { customerId: route.params.customerId } });
        }
      "
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { MetricSender } from "@/helpers/MetricSender";
import CalendarTestModeIndicator from "@components/CalendarTestModeIndicator.vue";
import AdminContext from "@logic/AdminContext";

// Components
import StepCalendarConfig from "./steps/StepCalendarConfig.vue";

// Types
// (imports moved to child component)

// Router
const route = useRoute();
const router = useRouter();

// Normalize route params ------------------------------------------------------
const customerId = computed<string>(() => (Array.isArray(route.params.customerId) ? route.params.customerId[0] : (route.params.customerId as string)));

defineOptions({
  name: "CalendarConfig",
});

onMounted(async () => {
  await AdminContext.setOrgInContextFromCustomerId(customerId.value);
  MetricSender.sendMetric("Cust-Calendar-Theme-PageView", { customerId: customerId.value });
});
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Content calendar new page ==================================================
.content-calendar-new-page {
  width: $desktop-wide-right-col-width;
  margin: 0 auto;

  &__progressbar {
    margin-bottom: 40px;
  }
}
.calendar-test-mode-indicator-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  position: sticky;
  top: 8px;
  z-index: 5;
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .content-calendar-new-page {
    width: $desktop-right-col-width;
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .content-calendar-new-page {
    width: $laptop-right-col-width;
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .content-calendar-new-page {
    width: $tablet-large-content-width;
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .content-calendar-new-page {
    width: $tablet-content-width;
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .content-calendar-new-page {
    width: $mobile-content-width;
  }
}
</style>
